var React = require('react');

function Mailbox (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2_00000017511008741832614750000003499738433221368474_"},React.createElement("g",{"id":"Layer_1-2"},React.createElement("path",{"d":"M56.7,15.2H32.6l1-2.5h11.1c0.9,0,1.7-0.6,2-1.4l3.2-8.3c0.3-0.7,0.2-1.4-0.2-2C49.3,0.3,48.6,0,47.9,0H32.6\n\t\t\tc-0.9,0-1.7,0.5-2,1.3l-5.6,13.8H6.8c-1.2,0-2.2,1-2.2,2.2v43.6c0,1.2,1,2.2,2.2,2.2h4c1.2,0,2.2-1,2.2-2.2V47.7h43.7\n\t\t\tc1.2,0,2.2-1,2.2-2.2V17.3C58.8,16.1,57.9,15.2,56.7,15.2z M54.5,43.4H9V19.5h14.2L20,27.4c-0.5,1.1,0.1,2.4,1.2,2.8\n\t\t\tc0.3,0.1,0.5,0.2,0.8,0.2h2.9c0.9,0,1.7-0.5,2-1.3l3.9-9.5h23.7V43.4z"}))));
}

Mailbox.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 63.5 63.1","style":{"enableBackground":"new 0 0 63.5 63.1"},"xmlSpace":"preserve"};

module.exports = Mailbox;

Mailbox.default = Mailbox;
